<ion-grid>
  <ion-row
    class="ion-align-items-start ion-justify-content-center"
    [class.multi-row]="columnCount < 12"
  >
    <ion-col
      *ngFor="let item of node?.items"
      size="12"
      [sizeMd]="columnCount"
      [innerHTML]="item.embed | safe: 'html'"
    ></ion-col>
  </ion-row>
</ion-grid>

<script-hack
  src="//www.instagram.com/embed.js"
  type="text/javascript"
></script-hack>
